const AbstractSyncer = require('@/lib/Syncing/AbstractSyncer');
const DataStoreNames = require('@/lib/DataStores/DataStoreNames');
const EventNames = require('@/lib/Events/EventNames');
const logFactory = require('@/libraries/DigiTickets/Logging/logFactory');

/**
 * Syncs things that need to be available immediately after logging in, before selecting a device.
 */
class PrivilegesSyncer extends AbstractSyncer {
    // This duplication of parameters being passed to the superclass' constructor looks silly but it's
    // necessary for Angular's injector to work.
    constructor(
        $injector,
        dataStore,
        eventBus,
        localStorageDataStore,
        syncStateManager
    ) {
        super(
            $injector,
            dataStore,
            eventBus,
            localStorageDataStore,
            syncStateManager
        );

        /**
         * @type {ConsoleLogger}
         */
        this.log = logFactory('PrivilegesSyncer');
    }

    getManagedTableNames() {
        return [
            DataStoreNames.PRIVILEGES,
        ];
    }

    getSyncFunctions() {
        return [
            this.createSyncRepositoryFunction(DataStoreNames.PRIVILEGES, 'privilegesRepository'),
        ];
    }

    requiresBranch() {
        return false;
    }

    onSyncFinish() {
        this.eventBus.broadcast(EventNames.PRIVILEGES_SYNCED);
    }
}

module.exports = PrivilegesSyncer;
